module.exports = __webpack_public_path__ + "static/media/elevator-ding.b4401e0c.mp3";